import React from "react";

const PlanetCard = ({ name, degree, icon, planets }) => {
  return (
    <div className="flex items-center justify-between w-full p-3 border-b border-[#e5e7eb]">
      <div className="flex items-center gap-3">
        <img
          src={icon}
          alt={name}
          className="w-8 h-8 rounded-full object-cover"
        />
        <div>
          <p className="text-[#3F414E] text-start text-xs font-medium">{name}</p>
          <p className="text-black/60 text-start text-xs">{planets.degree_formatted || `${degree}°`}</p>
        </div>
      </div>
      <div className="flex items-center gap-1 text-[#3F414E] justify-center text-xs ">
        <div> {planets.symbol} </div>
        <div> {planets.zodiac} </div>
      </div>
    </div>
  );
};

export default PlanetCard;
